import { render, staticRenderFns } from "./TeamGramChannels.vue?vue&type=template&id=1f954dd3&scoped=true"
import script from "./TeamGramChannels.vue?vue&type=script&lang=js"
export * from "./TeamGramChannels.vue?vue&type=script&lang=js"
import style0 from "./TeamGramChannels.vue?vue&type=style&index=0&id=1f954dd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f954dd3",
  null
  
)

export default component.exports